import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import Heading from "../../AdminComponents/Common/Heading";
import Overview from "../../AdminComponents/Dashboard/Overview";
import UpComingBooking from "../../AdminComponents/Dashboard/UpComingBooking";
import axios from "axios";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";
import { theme } from "../../Assets/Theme/theme";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate()
  const [dashboardData, setDashboardData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loginData = JSON.parse(localStorage.getItem("adminData"));
  const token = loginData?.token;

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/admin/dashboard`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDashboardData(response?.data || []);
    } catch (error) {
      if (error.response?.status === 401 || error.message.includes("Authentication")) {
        navigate("/login");
      } else {
      toast.error("Error fetching all data", {
        position: "top-right",
        autoClose: 3000,
      });
    }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return (
    <Box>
      <Heading label={"Dashboard"} />

      {loading ? <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={30} sx={{ color: theme.colors.orange }} />
      </Box> :

        <>
          <Box sx={{ marginTop: 2 }}>
            <Overview data={dashboardData} />
          </Box>
          <Box sx={{ marginTop: 4 }}>
            <UpComingBooking data={dashboardData?.booking} />
          </Box>
        </>}
    </Box>
  );
}

export default Dashboard;
